import React from 'react';

import { Amount } from '@klp/design/Amount';
import { Block } from '@klp/design/Block';

import type { IUtestaaendeFordringerResponse } from '../interfaces/IUtestaaendeFordringerResponse';

export type IUtestaaendeFordringerList = {
    forsinkede: IUtestaaendeFordringerResponse['forsinkede'];
};

export const UtestaaendeFordringerList: React.FC<
    IUtestaaendeFordringerList
> = ({ forsinkede }) => {
    return (
        <Block data-testid="UtestaaendeFordringerList" role="list">
            {forsinkede.length > 0 ? (
                forsinkede.map((el, index) => (
                    <Block
                        key={index}
                        klpTypographyVariant="small"
                        data-testid="UtestaaendeFordringer__Element"
                        role="row"
                    >
                        {/* eslint-disable-next-line i18next/no-literal-string */}
                        {el.kundeNavn} - <Amount value={el.sumForsinket} /> NOK
                        -{' '}
                        {/* eslint-disable-next-line i18next/no-literal-string */}
                        {el.maksAntallDagerForsinket}d
                    </Block>
                ))
            ) : (
                <Block
                    klpTypographyVariant="small"
                    translation="frontPage.utestaaendeFordringer.emptyResult"
                    data-testid="UtestaaendeFordringerList__NoResult"
                />
            )}
        </Block>
    );
};
